import React, { useEffect, useState } from 'react';
import { Filters } from './components/Filters/Filters';
import { TodoList } from './components/TodoList/TodoList';

function App() {
  const [currentTitleValue, setCurrentTitleValue] = useState('');
  const [todos, setTodos] = useState([]);
  const [visibleTodos, setVisibleTodos] = useState([]);
  const [typeFilter, setTypeFilter] = useState('All');

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('todos'))) {
      setTodos(JSON.parse(localStorage.getItem('todos')));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('todos', JSON.stringify(todos));
  }, [todos]);

  function addTodo() {
    setTodos([
      ...todos,
      {
        id: +Date.now(),
        todos: currentTitleValue,
        completed: false,
      },
    ]);
    setCurrentTitleValue('');
  }

  useEffect(() => {
    setVisibleTodos([
      todos,
    ]);
  }, [todos]);

  function changeProcessTodo(todoId) {
    if (typeof todoId === 'number') {
      setTodos(todos.map((todo) => {
        if (todo.id === todoId) {
          return {
            ...todo,
            completed: !todo.completed,
          };
        }

        return todo;
      }));
    } else {
      setTodos(todos.map(todo => (
        todos.every(item => (item.completed))
          ? ({
            ...todo,
            completed: false,
          })
          : ({
            ...todo,
            completed: true,
          })
      )));
    }
  }

  useEffect(() => {
    switch (typeFilter) {
      case 'All':
        setVisibleTodos(todos);
        break;
      case 'Active':
        setVisibleTodos(todos.filter(item => !item.completed));
        break;
      case 'Completed':
        setVisibleTodos(todos.filter(item => item.completed));
        break;
      default:
        break;
    }
  }, [typeFilter, todos]);

  const todoActiveCount = () => todos.filter(item => !item.completed === true);
  const todoDoneCount = () => todos.filter(item => item.completed === true);

  const deleteTodo = id => setTodos(todos.filter(item => item.id !== id));

  const changeTodoItem = (id, newTodo) => {
    setTodos(todos.map((todo) => {
      if (todo.id !== id) {
        return todo;
      }

      return {
        ...todo,
        todos: newTodo,
      };
    }));
  };

  return (
    <section className="todoapp">
      <header className="header">
        <h1>todos App</h1>

        <form onSubmit={(event) => {
          event.preventDefault();
        }}
        >
          <input
            type="text"
            className="new-todo"
            placeholder="What needs to be done?"
            value={currentTitleValue}
            onChange={({ target }) => setCurrentTitleValue(target
              .value.trimLeft())}
            onKeyDown={(event) => {
              ((event.key === 'Enter') && (currentTitleValue)) && (addTodo());
            }}
          />
        </form>
      </header>

      <section className="main">
        <input
          type="checkbox"
          id="toggle-all"
          className="toggle-all"
          onClick={() => changeProcessTodo()}
        />
        {(todos.length > 0) && (
          <label htmlFor="toggle-all">Mark all as complete</label>
        )}

        <TodoList
          todos={visibleTodos}
          changeProcessTodo={changeProcessTodo}
          deleteTodo={deleteTodo}
          changeTodoItem={changeTodoItem}
        />
      </section>
      {(todos.length > 0)
        && (
          <footer className="footer">
            <Filters
              todos={todos}
              setTodos={setTodos}
              setTypeFilter={setTypeFilter}
              todoActiveCount={todoActiveCount}
              todoDoneCount={todoDoneCount}
              typeFilter={typeFilter}
            />
          </footer>
        )
      }
    </section>
  );
}

export default App;
